import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http'
import 'rxjs/add/operator/toPromise'
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import { AppSettings } from '../_models/settings.models'

@Injectable()

export class AutentificacionService{

  constructor(private http: Http){

  }

  auth(){
    return this.http.get('https://jsonplaceholder.typicode.com/users')
            .map((response: Response) => {
                // login successful if there's a jwt token in the response
                console.log(response.json());

            });
  }

  //función para hacer login
  loginAuth(username: string, password: string) {

      //console.log(JSON.stringify({ user: username, pass: password }));

      let headers = new Headers({ 'Content-Type': 'application/json' });
      let options = new RequestOptions({ headers: headers});

      return this.http.post(AppSettings.API_URL, JSON.stringify({ user: username, pass: password, action: "userLogin", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              //console.log(response.json());

              let user = response.json(); //recogemos el json del control de usuario
              let error = user.error; //almacenamos el parámetro error

              let numerrores = Object.keys(error).length; // miramos si llega vacío

              if (user && user.tokenid && numerrores == 0) {
                console.log("Me logo");
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('currentUser', JSON.stringify(user));
                localStorage.setItem('currentUserToken', user.tokenid);
                localStorage.setItem('currentUserName', user.nombre);
              }else{
                console.log("No Me logo");
                this.logout();
              }

              return user;

          });
  }

  //funcion para comprobar si el tokeid está activo aún
  isLoginActive(tokenid: string){
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers});

    return this.http.post(AppSettings.API_URL, JSON.stringify({ tokenid: tokenid, action: "userIsLogin", api_keytoken: AppSettings.API_KEYTOKEN  }))
        .map((response: Response) => {

          return response.json();

        });
  }

  logout() {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers});

    let tokenid : string = localStorage.getItem('currentUserToken');

    // quitamos todas las localStorage
    localStorage.removeItem('currentUser');
    localStorage.removeItem('currentUserToken');
    localStorage.removeItem('currentUserName');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ tokenid: tokenid, action: "userLogout", api_keytoken: AppSettings.API_KEYTOKEN  }))
        .map((response: Response) => {
          console.log(response.json());
        });

  }



}



// WEBPACK FOOTER //
// ./src/app/_services/autentificacion.service.ts